import { createSelector } from 'reselect';
import { Map } from 'immutable';

const selectFundingEnquiry = (state) => state.get('fundingEnquiry');

const makeSelectUpdateStatus = () =>
  createSelector(selectFundingEnquiry, (state) => state.get('updateStatus', Map()));

const makeSelectUpdateStatusError = () =>
  createSelector(makeSelectUpdateStatus(), (state) => state.getIn(['network', 'error']));

const makeSelectUpdateStatusLoading = () =>
  createSelector(makeSelectUpdateStatus(), (state) => state.getIn(['network', 'loading']));

export { makeSelectUpdateStatusError, makeSelectUpdateStatusLoading };
